import { authFetch } from '@/utils/http'
import { API_ROUTE } from '../backend/config'
import { SendSupportEmailForm } from './types'

export const sendSupportEmail = async (params: SendSupportEmailForm) => {
  const body = new FormData()
  body.append('email', params.email)
  body.append('description', params.description)

  if (params.dateOfIncident) {
    body.append('dateOfIncident', params.dateOfIncident)
  }

  if (params.files) {
    params.files.forEach((file) => {
      body.append('files', file)
    })
  }

  if (params.transcript) {
    body.append('transcript', params.transcript)
  }

  const response = await authFetch(`${API_ROUTE}/support/contact`, {
    method: 'POST',
    body,
  })

  const jsonResponse = await response.json()

  return jsonResponse
}
